export default "__VITE_ASSET__BKmhTqcy__"